import "%components%/m-slider/m-slider";
import "%components%/chart/chart";
import "%components%/circle-chart/circle-chart";
import "%components%/linear-chart/linear-chart";
import "%components%/custom-select/custom-select";
import "%components%/textarea/textarea";
import "%components%/dropdown/dropdown";
import "%components%/input/input";
import "%components%/upload-files/upload-files";
import "%components%/notification/notification";
import "%components%/banner/banner";
import "%components%/event-slider/event-slider";
